export default [
  {
    'label': '微笑',
    'icon': 'smile',
    'value': 'Smile'
  },
  {
    'label': '撇嘴',
    'icon': 'grimace',
    'value': 'Grimace'
  },
  {
    'label': '色',
    'icon': 'drool',
    'value': 'Drool'
  },
  {
    'label': '发呆',
    'icon': 'scowl',
    'value': 'Scowl'
  },
  {
    'label': '得意',
    'icon': 'coolguy',
    'value': 'CoolGuy'
  },
  {
    'label': '流泪',
    'icon': 'sob',
    'value': 'Sob'
  },
  {
    'label': '害羞',
    'icon': 'shy',
    'value': 'Shy'
  },
  {
    'label': '闭嘴',
    'icon': 'silent',
    'value': 'Silent'
  },
  {
    'label': '睡',
    'icon': 'sleep',
    'value': 'Sleep'
  },
  {
    'label': '大哭',
    'icon': 'cry',
    'value': 'Cry'
  },
  {
    'label': '尴尬',
    'icon': 'awkward',
    'value': 'Awkward'
  },
  {
    'label': '发怒',
    'icon': 'angry',
    'value': 'Angry'
  },
  {
    'label': '调皮',
    'icon': 'tongue',
    'value': 'Tongue'
  },
  {
    'label': '呲牙',
    'icon': 'grin',
    'value': 'Grin'
  },
  {
    'label': '惊讶',
    'icon': 'surprise',
    'value': 'Surprise'
  },
  {
    'label': '难过',
    'icon': 'frown',
    'value': 'Frown'
  },
  {
    'label': '酷',
    'icon': 'ruthless',
    'value': 'Ruthless'
  },
  {
    'label': '囧',
    'icon': 'blush',
    'value': 'Blush'
  },
  {
    'label': '抓狂',
    'icon': 'scream',
    'value': 'Scream'
  },
  {
    'label': '吐',
    'icon': 'puke',
    'value': 'Puke'
  },
  {
    'label': '偷笑',
    'icon': 'chuckle',
    'value': 'Chuckle'
  },
  {
    'label': '愉快',
    'icon': 'joyful',
    'value': 'Joyful'
  },
  {
    'label': '白眼',
    'icon': 'slight',
    'value': 'Slight'
  },
  {
    'label': '傲慢',
    'icon': 'smug',
    'value': 'Smug'
  },
  {
    'label': '饥饿',
    'icon': 'hungry',
    'value': 'Hungry'
  },
  {
    'label': '困',
    'icon': 'drowsy',
    'value': 'Drowsy'
  },
  {
    'label': '惊恐',
    'icon': 'panic',
    'value': 'Panic'
  },
  {
    'label': '流汗',
    'icon': 'sweat',
    'value': 'Sweat'
  },
  {
    'label': '憨笑',
    'icon': 'laugh',
    'value': 'Laugh'
  },
  {
    'label': '悠闲',
    'icon': 'commando',
    'value': 'Commando'
  },
  {
    'label': '愤怒',
    'icon': 'determined',
    'value': 'Determined'
  },
  {
    'label': '咒骂',
    'icon': 'scold',
    'value': 'Scold'
  },
  {
    'label': '疑惑',
    'icon': 'shocked',
    'value': 'Shocked'
  },
  {
    'label': '嘘',
    'icon': 'shhh',
    'value': 'Shhh'
  },
  {
    'label': '晕',
    'icon': 'dizzy',
    'value': 'Dizzy'
  },
  {
    'label': '疯了',
    'icon': 'tormented',
    'value': 'Tormented'
  },
  {
    'label': '衰',
    'icon': 'toasted',
    'value': 'Toasted'
  },
  {
    'label': '骷髅',
    'icon': 'skull',
    'value': 'Skull'
  },
  {
    'label': '敲打',
    'icon': 'hammer',
    'value': 'Hammer'
  },
  {
    'label': '再见',
    'icon': 'wave',
    'value': 'Bye'
  },
  {
    'label': '擦汗',
    'icon': 'speechless',
    'value': 'Speechless'
  },
  {
    'label': '抠鼻',
    'icon': 'nosepick',
    'value': 'NosePick'
  },
  {
    'label': '鼓掌',
    'icon': 'clap',
    'value': 'Clap'
  },
  {
    'label': '糗大了',
    'icon': 'shame',
    'value': 'Shame'
  },
  {
    'label': '坏笑',
    'icon': 'trick',
    'value': 'Trick'
  },
  {
    'label': '左哼哼',
    'icon': 'bah',
    'value': 'Bah！L'
  },
  {
    'label': '右哼哼',
    'icon': 'bah_1',
    'value': 'Bah！R'
  },
  {
    'label': '哈欠',
    'icon': 'yawn',
    'value': 'Yawn'
  },
  {
    'label': '鄙视',
    'icon': 'pooh-pooh',
    'value': 'Pooh-pooh'
  },
  {
    'label': '委屈',
    'icon': 'shrunken',
    'value': 'Shrunken'
  },
  {
    'label': '快哭',
    'icon': 'tearingup',
    'value': 'TearingUp'
  },
  {
    'label': '阴险',
    'icon': 'sly',
    'value': 'Sly'
  },
  {
    'label': '亲亲',
    'icon': 'kiss',
    'value': 'Kiss'
  },
  {
    'label': '吓',
    'icon': 'wrath',
    'value': 'Wrath'
  },
  {
    'label': '可怜',
    'icon': 'whimper',
    'value': 'Whimper'
  },
  {
    'label': '菜刀',
    'icon': 'cleaver',
    'value': 'Cleaver'
  },
  {
    'label': '西瓜',
    'icon': 'watermelon',
    'value': 'Watermelon'
  },
  {
    'label': '啤酒',
    'icon': 'beer',
    'value': 'Beer'
  },
  {
    'label': '篮球',
    'icon': 'basketball',
    'value': 'Basketball'
  },
  {
    'label': '乒乓',
    'icon': 'pingpong',
    'value': 'PingPong'
  },
  {
    'label': '咖啡',
    'icon': 'coffee',
    'value': 'Coffee'
  },
  {
    'label': '饭',
    'icon': 'rice',
    'value': 'Rice'
  },
  {
    'label': '猪头',
    'icon': 'pig',
    'value': 'Pig'
  },
  {
    'label': '玫瑰',
    'icon': 'rose',
    'value': 'Rose'
  },
  {
    'label': '凋谢',
    'icon': 'wilt',
    'value': 'Wilt'
  },
  {
    'label': '嘴唇',
    'icon': 'lips',
    'value': 'Lips'
  },
  {
    'label': '爱心',
    'icon': 'heart',
    'value': 'Heart'
  },
  {
    'label': '心碎',
    'icon': 'brokenheart',
    'value': 'BrokenHeart'
  },
  {
    'label': '蛋糕',
    'icon': 'cake',
    'value': 'Cake'
  },
  {
    'label': '闪电',
    'icon': 'lightning',
    'value': 'Lightning'
  }]



// WEBPACK FOOTER //
// ./src/components/emoji-input/source/data/emojiConfig.js